export default "__VITE_ASSET__BMmx92zv__"